import "./App.css";
import Home from "./components/zHome/Home";

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
